import styled from '@emotion/styled';
import {TableCell} from "@mui/material";

export const PolicyTableCell = styled(TableCell)({
    fontFamily:"Work Sans",
    fontWeight: 400,
    fontSize: "1rem",
    lineHeight: 1.7,
    padding: "2rem 1rem",
    textAlign:"center",
    color:"#2A1D22"
  });